/* unplugin-vue-components disabled */import { render } from "./UserSign.vue?vue&type=template&id=fc7db442&scoped=true"
import script from "./UserSign.vue?vue&type=script&lang=js"
export * from "./UserSign.vue?vue&type=script&lang=js"

import "./UserSign.vue?vue&type=style&index=0&id=fc7db442&scoped=true&lang=css"

import exportComponent from "/Users/rabbuse/Project/Vue/plp-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fc7db442"]])

export default __exports__